import React from 'react';
import { Warning } from '@phosphor-icons/react';
import {
    isDashboardCustomerSectionReady,
    type SystemDesignMissingItem,
    type SystemDesignMissingItemId,
} from './systemDesignMissingItems';

export type SystemDesignMissingBannerProps = {
    items: SystemDesignMissingItem[];
    onFixItem: (id: SystemDesignMissingItemId) => void;
};

export const SystemDesignMissingBanner: React.FC<SystemDesignMissingBannerProps> = ({ items, onFixItem }) => {
    if (items.length === 0) return null;

    const customerReady = isDashboardCustomerSectionReady(items);
    const title = customerReady
        ? 'Required before pricing and quotes — complete in order'
        : 'Required before System & Design — complete customer steps first';

    return (
        <section className="obd-system-design-missing" aria-label="Required steps before pricing and quotes">
            <div className="obd-system-design-missing__head">
                <Warning size={18} weight="fill" className="obd-system-design-missing__icon" aria-hidden />
                <span className="obd-system-design-missing__title">{title}</span>
            </div>
            <ul className="obd-system-design-missing__list" role="list">
                {items.map((item) => (
                    <li key={item.id} className="obd-system-design-missing__row" role="listitem">
                        <div className="obd-system-design-missing__row-main">
                            <span className="obd-system-design-missing__row-label">
                                {item.step != null ? `${item.step}. ` : ''}
                                {item.label}
                            </span>
                            <span
                                className={`obd-system-design-missing__badge obd-system-design-missing__badge--${item.severity}`}
                            >
                                {item.severityLabel}
                            </span>
                        </div>
                        <button
                            type="button"
                            className="obd-system-design-missing__fill-btn"
                            onClick={() => onFixItem(item.id)}
                        >
                            Fill in
                        </button>
                    </li>
                ))}
            </ul>
        </section>
    );
};
